import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Customer Product Match DTO Schema
 */
export const CustomerProductMatchSchema = z.object({
  id: z.uuid(),
  customerId: z.uuid(),
  productId: z.uuid(),
  productVariantId: z.uuid(),

  // Customer identifier fields
  customerDescription: z.string().nullable(),
  customerMainIdentifier: z.string().nullable(),
  customerSku: z.string().nullable(),
  customerUpc: z.string().nullable(),
  customerPlu: z.string().nullable(),
  customerEan: z.string().nullable(),
  customerGtin: z.string().nullable(),
  customerAsin: z.string().nullable(),
  customerMpn: z.string().nullable(),
  customerIsbn: z.string().nullable(),
  customerNsn: z.string().nullable(),
  customerFreeform: z.array(z.string()).nullable(),

  customer: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  product: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  productVariant: z.object({
    id: z.uuid(),
    name: z.string(),
    sku: z.string().nullable(),
    active: z.boolean(),
  }),

  matchSequence: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

/**
 * List Customer Product Matches Query Schema
 */
export const ListCustomerProductMatchesQuerySchema = z.object({
  customerId: z.uuid().optional(),
  productId: z.uuid().optional(),
  search: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).prefault(25),
  offset: z.coerce.number().int().min(0).prefault(0),
});

/**
 * List Customer Product Matches Response Schema
 */
export const ListCustomerProductMatchesResponseSchema = z.object({
  customerProductMatches: z.array(CustomerProductMatchSchema),
  pagination: z.object({
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  }),
});

/**
 * Customer Products Contracts
 */
export const customerProductsContracts = {
  list: oc
    .input(ListCustomerProductMatchesQuerySchema)
    .output(ListCustomerProductMatchesResponseSchema)
    .route({
      method: "GET",
      path: "/customer-products",
    }),
} as const;

// Export types
export type CustomerProductMatch = z.infer<typeof CustomerProductMatchSchema>;
export type ListCustomerProductMatchesQuery = z.infer<
  typeof ListCustomerProductMatchesQuerySchema
>;
export type ListCustomerProductMatchesResponse = z.infer<
  typeof ListCustomerProductMatchesResponseSchema
>;
